import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

import { ExamGroupService } from '../../service/exam-group.service';
import { ExamTemplateService } from '../../service/exam-template.service';
import { ExamTemplate } from '../exam-template';
import { ExamGroup } from '../../exam-group/exam-group';

@Component({
  selector: 'mc-exam-template-show',
  templateUrl: './exam-template-show.component.html'
})
export class ExamTemplateShowComponent implements OnInit {

  examTemplate: ExamTemplate;
  examGroups: ExamGroup[];

  constructor(
    private examTemplateService: ExamTemplateService,
    private examGroupService: ExamGroupService,
    private route: ActivatedRoute,
    private location: Location,
    private notifService: ToastrService
  ) {}

  ngOnInit() {
    this.loadExamTemplate();
    this.examGroupService.getAll().subscribe(
      groups => this.examGroups = groups
    );
  }

  loadExamTemplate(): void {
    const id = +this.route.snapshot.paramMap.get('id');
    this.examTemplateService.get(id).subscribe(
      template => this.examTemplate = template
    );
  }

  save(): void {
    if (this.examTemplate) {
      this.examTemplateService.update(this.examTemplate).subscribe(
        template => {
          this.notifService.success('Procedimento atualizado');
          this.location.back();
        },
        error => this.notifService.error(error)
      );
    }
  }

  goBack(): void {
    this.location.back();
  }
}
